module.exports = __webpack_public_path__ + "static/media/Illus-Spring@3x.8061f43d.png";